// highlight.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'highlight' })
export class HighlightPipe implements PipeTransform {
  transform(text: string, keywords: string[]): string {
    if (!text || !keywords || keywords.length === 0) {
      return text || '';
    }

    const regex = new RegExp(keywords.map(keyword => this.escapeRegExp(keyword)).join('|'), 'gi');
    return text.replace(regex, match => `<span class="highlight">${match}</span>`);
  }

  private escapeRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
}

